
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

// SERVICES
import { CuentasService } from 'src/app/services/cuentas_maestras.service';
import {ChannelsandoperationsService} from 'src/app/services/channelsandoperations.service';
import {TiposOperacionesService} from 'src/app/services/tipos_operaciones.service';
import {CargaService} from 'src/app/services/carga.service';

@Component({
  selector: 'app-cargar-operaciones',
  templateUrl: './cargar-operaciones.component.html',
  styleUrls: ['./cargar-operaciones.component.scss']
})
export class CargarOperacionesComponent implements OnInit {
  canales;
  tiposOperaciones;
  formOperacion = this.fb.group({
    fecha: ['', [Validators.required,]],
    ip: ['', [Validators.required, Validators.max(15)]],
    ip_no_financiera: ['', [Validators.required, Validators.max(15)]],
    especialista: ['', [Validators.required, Validators.max(30)]],
    observacion: ['', [Validators.required, Validators.max(30)]],
    id_operaciones_relacion: ['', [Validators.required]],
    borrado: [0],
    id_sakes: [sessionStorage.getItem("id_carga")],
    id_canales: ['', [Validators.required, Validators.max(30)]],
    id_tipos_operaciones: ['', [Validators.required, Validators.max(30)]],
  });
  formCuentaOrigen = this.fb.group({
    id_cuentas:[,[Validators.required]]
  });
  formOperacionCuentaOrigen = this.fb.group({
    tipo:["Origen"],
    monto_ejecutado:['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    monto_retenido:['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    monto_recibido:['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    monto_salvado:['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    borrado:[0],
  });
  formCuentaDestino = this.fb.group({
    titular: ['', [Validators.required, Validators.max(30)]],
    tipo_documento: ['', [Validators.required, Validators.maxLength(1)]],
    numero_documento_cuenta: ['',[Validators.required, Validators.pattern('^[0-9]*$')],],
    numero_cuenta: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    tipo_cuenta: ['Corriente'],
    borrado: [0],
    id_usuarios_creador: [sessionStorage.getItem('id_usuario')],
  });
  formOperacionCuentaDestino = this.fb.group({
    tipo:["Destino"],
    monto_ejecutado:['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    monto_retenido:['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    monto_recibido:['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    monto_salvado:['', [Validators.required, Validators.pattern('^[0-9]*$')]],
    borrado:[0]
  });
  tiposDocumentos: any = [{ name: 'V' }, { name: 'J' }, { name: 'E' }];
  constructor(
    public dialogRef: MatDialogRef<CargarOperacionesComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _snackBar: MatSnackBar,
    private cuentasService: CuentasService,
    private canalesService: ChannelsandoperationsService,
    private tiposOperacionesService:TiposOperacionesService,
    private cargaService:CargaService
  ) {}
  ngOnInit(): void {
    this.canalesService.getChannels().subscribe(async(result:any)=>{
      this.canales = result.payload;
    })
    this.cargaService.consultar(sessionStorage.getItem("id_carga")).subscribe(async(data:any)=>{
      //console.log("Obteniendo la carga")
      //console.log(data)
    });
  }
  obtenerTipoDeOperacion(){
    //console.log(this.formOperacion.value.id_canales)
    this.tiposOperacionesService.obtenerId(this.formOperacion.value.id_canales).subscribe(async(result:any)=>{
      //console.log("Obtuve el tipo operacion")
      //console.log(result)
      this.tiposOperaciones = result.payload.data;
    });
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  onSubmit() {
    // //console.log(this.form.value);
    // this.cuentasService.crear(this.form.value).subscribe((data) => {
    //   //console.log(data);
    //   this.openSnackBar('Tipo Operación creado con éxito', 'X');
    //   this.dialogRef.close();
    // });
  }
}

